import React from 'react'
import BackgroundMoohNews from '@assets/images/Design-ohne-Titel-24.png'
import pdfDeApr from '@assets/pdfs/DE_Produzenten-Info_Juni_2026_Web.pdf'
import pdfFrApr from '@assets/pdfs/FR_Produzenten-Info_Juni_2026_Web.pdf'

export interface AbrechnungItem {
  id: string
  month: string
  year: number
  amount: number
  currency: string
}

export interface MilchpreisBreakdown {
  label: string
  value: number
  color: string
}

export interface MilchpreisData {
  totalPrice: number
  breakdown: MilchpreisBreakdown[]
  bottleData: {
    label: string
    value: number
    color: string
  }[]
}

export interface MilchqualitaetData {
  fett: number
  eiweiss: number
  zellzahl: number
  keimzahl: number
}

export interface MilchmengeDataPoint {
  day: number
  amount: number
}

export const mockAbrechnungen: AbrechnungItem[] = [
  { id: '1', month: 'Dezember', year: 2025, amount: 32151.10, currency: 'CHF' },
  { id: '2', month: 'November', year: 2025, amount: 28211.15, currency: 'CHF' },
  { id: '3', month: 'Oktober', year: 2025, amount: 31900.90, currency: 'CHF' },
  { id: '4', month: 'September', year: 2025, amount: 26214.80, currency: 'CHF' },
  { id: '5', month: 'August', year: 2025, amount: 36589.75, currency: 'CHF' }
]
 
export const mockMilchpreisData: MilchpreisData = {
  totalPrice: 61.17,
  breakdown: [
    { label: 'Basispreis', value: 55.00, color: '#4CAF50' },
    { label: 'Fett', value: 1.44, color: '#8BC34A' },
    { label: 'Eiweiss', value: 2.34, color: '#CDDC39' },
    { label: 'Planungsbonus', value: 1.50, color: '#FFC107' },
    { label: 'NH Zuschlage', value: 1.59, color: '#03A9F4' },
    { label: 'div. Zuschlage', value: -0.45, color: '#F44336' },
    { label: 'div. Abzuge', value: -2.15, color: '#E91E63' }
  ],
  bottleData: [
    { label: 'Fett', value: 8, color: '#2E7D32' },
    { label: 'Eiweiss', value: 7, color: '#388E3C' },
    { label: 'Planungsbonus', value: 6, color: '#43A047' },
    { label: 'NH Zuschlage', value: 5, color: '#4CAF50' },
    { label: 'Qualitatszuschlage /-abzuge', value: 4, color: '#66BB6A' },
    { label: 'Zuschlage ausgerechnet', value: 70, color: '#81C784' }
  ]
}

// Milk quality history chart data point
export interface MilkQualityChartDataPoint {
  date: string
  value: number
  isAboveLimit?: boolean
  isBelowLimit?: boolean
}

// Extended milk quality data with history
export interface MilchqualitaetDataExtended extends MilchqualitaetData {
  fettHistory: MilkQualityChartDataPoint[]
  eiweissHistory: MilkQualityChartDataPoint[]
  zellzahlHistory: MilkQualityChartDataPoint[]
  keimzahlHistory: MilkQualityChartDataPoint[]
}

// Mock Milchqualitaet data
export const mockMilchqualitaetData: MilchqualitaetData = {
  fett: 4.5,
  eiweiss: 3.82,
  zellzahl: 226000,
  keimzahl: 4000
}

// Mock chart history data based on the provided mockup
export const mockMilchqualitaetHistoryData: MilchqualitaetDataExtended = {
  fett: 4.4,
  eiweiss: 3.86,
  zellzahl: 265000,
  keimzahl: 15000,
  fettHistory: [
    { date: '08.07.2025', value: 4.01, isAboveLimit: true },
    { date: '07.08.2025', value: 3.95, isBelowLimit: true },
    { date: '07.08.2025', value: 3.94, isBelowLimit: true },
    { date: '04.09.2025', value: 3.91, isBelowLimit: true },
    { date: '04.09.2025', value: 3.95, isBelowLimit: true },
    { date: '16.10.2025', value: 4.38, isAboveLimit: true },
    { date: '16.10.2025', value: 4.34, isAboveLimit: true },
    { date: '11.11.2025', value: 4.46, isAboveLimit: true },
    { date: '11.11.2025', value: 4.42, isAboveLimit: true },
    { date: '01.12.2025', value: 4.32, isAboveLimit: true },
    { date: '01.12.2025', value: 4.33, isAboveLimit: true },
    { date: '01.12.2025', value: 4.4, isAboveLimit: true }
  ],
  eiweissHistory: [
    { date: '08.07.2025', value: 3.65, isAboveLimit: true },
    { date: '07.08.2025', value: 3.53, isAboveLimit: true },
    { date: '07.08.2025', value: 3.61, isAboveLimit: true },
    { date: '04.09.2025', value: 3.69, isAboveLimit: true },
    { date: '04.09.2025', value: 3.71, isAboveLimit: true },
    { date: '16.10.2025', value: 3.85, isAboveLimit: true },
    { date: '16.10.2025', value: 3.97, isAboveLimit: true },
    { date: '11.11.2025', value: 3.89, isAboveLimit: true },
    { date: '11.11.2025', value: 3.92, isAboveLimit: true },
    { date: '01.12.2025', value: 3.87, isAboveLimit: true },
    { date: '01.12.2025', value: 3.9, isAboveLimit: true },
    { date: '01.12.2025', value: 3.86, isAboveLimit: true }
  ],
  zellzahlHistory: [
    { date: '08.07.2025', value: 268000 },
    { date: '07.08.2025', value: 216000 },
    { date: '07.08.2025', value: 271000 },
    { date: '04.09.2025', value: 267000 },
    { date: '04.09.2025', value: 197000 },
    { date: '16.10.2025', value: 223000 },
    { date: '16.10.2025', value: 234000 },
    { date: '11.11.2025', value: 310000, isAboveLimit: true },
    { date: '11.11.2025', value: 322000, isAboveLimit: true },
    { date: '01.12.2025', value: 253000 },
    { date: '01.12.2025', value: 227000 },
    { date: '01.12.2025', value: 265000 }
  ],
  keimzahlHistory: [
    { date: '08.07.2025', value: 6000, isAboveLimit: false },
    { date: '07.08.2025', value: 14000, isAboveLimit: true },
    { date: '07.08.2025', value: 13000, isAboveLimit: true },
    { date: '04.09.2025', value: 9000 },
    { date: '04.09.2025', value: 10000 },
    { date: '16.10.2025', value: 9000 },
    { date: '16.10.2025', value: 12000, isAboveLimit: true },
    { date: '11.11.2025', value: 5000 },
    { date: '11.11.2025', value: 4000 },
    { date: '01.12.2025', value: 9000 },
    { date: '01.12.2025', value: 19000, isAboveLimit: true },
    { date: '01.12.2025', value: 15000, isAboveLimit: true }
  ]
}

// Mock Milchmenge data (daily data for a month)
export const mockMilchmengeData: MilchmengeDataPoint[] = [
  { day: 2, amount: 2800 },
  { day: 3, amount: 2850 },
  { day: 4, amount: 2900 },
  { day: 5, amount: 2950 },
  { day: 6, amount: 3000 },
  { day: 7, amount: 3050 },
  { day: 8, amount: 3100 },
  { day: 9, amount: 3050 },
  { day: 10, amount: 3000 },
  { day: 11, amount: 2950 },
  { day: 12, amount: 2900 },
  { day: 13, amount: 2850 },
  { day: 14, amount: 2900 },
  { day: 15, amount: 3100 },
  { day: 16, amount: 3200 },
  { day: 17, amount: 3300 },
  { day: 18, amount: 3350 },
  { day: 19, amount: 3300 },
  { day: 20, amount: 3250 }
]

// Helper to generate month options
export const getMonthOptions = () => [
  { key: 1, value: 1, text: 'Januar' },
  { key: 2, value: 2, text: 'Februar' },
  { key: 3, value: 3, text: 'Marz' },
  { key: 4, value: 4, text: 'April' },
  { key: 5, value: 5, text: 'Mai' },
  { key: 6, value: 6, text: 'Juni' },
  { key: 7, value: 7, text: 'Juli' },
  { key: 8, value: 8, text: 'August' },
  { key: 9, value: 9, text: 'September' },
  { key: 10, value: 10, text: 'Oktober' },
  { key: 11, value: 11, text: 'November' },
  { key: 12, value: 12, text: 'Dezember' }
]

// Helper to generate year options
export const getYearOptions = () => [
  { key: 2024, value: 2024, text: '2024' },
  { key: 2025, value: 2025, text: '2025' },
  { key: 2026, value: 2026, text: '2026' }
]

// Aktuelles (News) widget data
export interface AktuellesAction {
  label: string
  url: string
  tooltip?: string
  download?: boolean
}

export interface NewsSectionType {
  id: string
  title: string
  date: string
  description?: React.ReactNode
  actions: AktuellesAction[]
  backgroundImage?: any
}

const pdfUrlMap: Record<string, string> = {
  'de-4': pdfDeApr,
  'fr-4': pdfFrApr
}

const pdfLabelDE: Record<number, string> = {
  4: 'Produzenten-Info Juni 2026'
}

const pdfLabelFR: Record<number, string> = {
  4: 'Info producteurs Juin 2026'
}

export const buildNewsData = (lang: 'de' | 'fr'): NewsSectionType[] => {
  const pdfMonths = [4]
  const produzentActions: AktuellesAction[] = pdfMonths
    .filter((month) => pdfUrlMap[`${lang}-${month}`])
    .map((month) => ({
      label: lang === 'fr' ? (pdfLabelFR[month] ?? `Info producteurs ${month} 2026`) : (pdfLabelDE[month] ?? `Produzenten-Info ${month} 2026`),
      url: pdfUrlMap[`${lang}-${month}`],
      tooltip: lang === 'fr'
        ? `Téléchargement PDF : ${pdfLabelFR[month]}`
        : `PDF Download: ${pdfLabelDE[month]}`,
      download: true
    }))

  if (lang === 'fr') {
    return [
      {
        id: 'produzenten-info',
        title: 'Nouveau Info producteurs',
        date: '15.06.2026',
        description: 'Les contributions individuelles sont également disponibles ici',
        actions: produzentActions
      },
      {
        id: 'blauzungenvirus',
        title: 'Lien vers la newsletter : Virus de la langue bleue',
        date: '16.10.2024',
        actions: [],
        backgroundImage: BackgroundMoohNews
      },
      {
        id: 'bewirtschafterwechsel',
        title: 'Changement d\'exploitant',
        date: '11.09.2024',
        description: 'Prière de s\'annoncer à temps auprès de mooh et de TSM Fiduciaire au moyen des formulaires suivants :',
        actions: []
      },
      {
        id: 'zwei-faktor',
        title: 'Supprimer l\'authentification à deux facteurs',
        date: '13.10.2022',
        description: 'Vous n\'avez pas besoin d\'une authentification à deux facteurs pour l\'intranet mooh. Barto explique dans une vidéo comment vous pouvez supprimer l\'authentification à deux facteurs.',
        actions: []
      },
      {
        id: 'sprache',
        title: 'Sprache / Langue',
        date: '06.04.2021',
        description: <div>
          <p>{'Pour changer la langue vous pouvez cliquer sur votre adresse mail en haut à droit.'}</p>
          <p>{'Um die Sprache zu wechseln, klicken Sie oben rechts auf Ihre E-Mail-Adresse.'}</p>
        </div>,
        actions: []
      }
    ]
  }

  return [
    {
      id: 'produzenten-info',
      title: 'Produzenten-Info',
      date: '13.05.2026',
      description: 'Die einzelnen Beiträge sind auch hier aufgeschaltet:',
      actions: produzentActions
    },
    {
      id: 'blauzungenvirus',
      title: 'Newsletter Link: Blauzungenvirus',
      date: '16.10.2024',
      actions: [],
      backgroundImage: BackgroundMoohNews
    },
    {
      id: 'bewirtschafterwechsel',
      title: 'Bewirtschafterwechsel',
      date: '11.09.2024',
      description: 'Bitte um frühzeitige Meldung bei mooh und TSM Treuhand mit folgenden Formularen:',
      actions: []
    },
    {
      id: 'zwei-faktor',
      title: 'Zwei-Faktor-Authentifizierung entfernen',
      date: '13.10.2022',
      description: 'Für das mooh Intranet benötigt Ihr keine Zwei-Faktor-Authentifizierung. Barto erklärt in einem Video, wie Du die Zwei-Faktor-Authentifizierung wieder entfernst.',
      actions: []
    },
    {
      id: 'sprache',
      title: 'Sprache / Langue',
      date: '06.04.2021',
      description: <div>
        <p>{'Um die Sprache zu wechseln, klicken Sie oben rechts auf Ihre E-Mail-Adresse.'}</p>
        <p>{'Pour changer la langue vous pouvez cliquer sur votre adresse mail en haut à droit.'}</p>
      </div>,
      actions: []
    }
  ]
}
